/**
 * @class PrinterTemplate
 */
export default class PrinterTemplate {
    /**
     * @param {String}  name
     * @param {String}  file
     * @param {String}  path
     */
    constructor(name, file = "", path = "") {
        this._name = name;
        this._file = file;
        this._path = path;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get file() {
        return this._file;
    }

    /**
     * @param {String} file
     */
    set file(file) {
        this._file = file;
    }

    /**
     * @return {String}
     */
    get path() {
        return this._path;
    }

    /**
     * @param {String} path
     */
    set path(path) {
        this._path = path;
    }
}
